/**
 * Still Kicking: crawl further, and last longer doing it.
 *
 * The pair of levers is the point. Longer on the clock is only worth something if you can cover
 * ground with it, and crawling out of the room you were shot in is the play this perk buys.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const STILL_KICKING = {
  id: 'stillKicking',
  branch: 'survival',
  tier: 3,
  title: 'Still Kicking',
  blurb: 'Report to the assembly point. Crawling is a recognised means of reporting.',
  maxRanks: 2,
  minLevel: 17,
  requires: ['tourniquetDrill'],
  statGrants: {},
  effects: [
    { field: 'bleedoutSeconds', perRank: 0.09, condition: 'whileDowned' },
    { field: 'moveSpeed', perRank: 0.05, condition: 'whileDowned' },
  ],
  damageModifiers: [],
} as const satisfies Perk;
